import { Component, Prop } from 'vue-property-decorator'
import { BaseTable } from '@/mixins/Base'
import { ResourceFileDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { isNull } from 'lodash'
import { humanStorageSize } from '@/utils'
import {canPreviewList} from '@/utils/commonDef'

@Component
export default class FileTable extends BaseTable<ResourceFileDto> {
  @Prop({ default: false }) readOnly: boolean
  @Prop({ default: false }) isCompare: boolean
  @Prop({ default: false }) isDraftedOrPublished: boolean
  @Prop({ default: true }) canView: boolean
  
  public viewContentType = canPreviewList
  get columns() {
    if (this.readOnly) {
      return [
        {
          customRender: (_value, record, index) => {
            if (this.isDraftedOrPublished) {
              let a = []
              if(this.canEdit(record)) {
                a=a.concat([
                  <a-icon
                    style="cursor: pointer; color: #52c41a;"
                    type="file-search"
                    onClick={() => this.$emit('preview', record)}
                  />
                ])
              }
              return a
            } else {
              let a = []
              if(this.canEdit(record)) {
                a=a.concat([
                  <a-icon
                    style="cursor: pointer; color: #52c41a;"
                    type="file-search"
                    onClick={() => this.$emit('preview', record)}
                  />
                ])
              }
              return a
            }
          },
          width: '10%',
          align: 'center',
        },
        {
          title: this.$t('page_resource_pool_file_name'),
          dataIndex: 'displayName',
          ellipsis: true,
          width: '40%',
        },
        {
          title: this.$t('page_resource_pool_size'),
          dataIndex: 'contentLength',
          customRender: val => {
            return humanStorageSize(val)
          },
          width: '25%',
        },
        {
          title: this.$t('page_resource_pool_file_type'),
          dataIndex: 'suffix',
          width: '25%',
        },
      ]
    } else {
      return [
        {
          customRender: (_value, record, index) => {
            if (this.isDraftedOrPublished) {
              let a = [
                <a-icon
                  style="cursor: pointer; color: #4a90e2;"
                  type="retweet"
                  onClick={() => this.$emit('replace', { record, index })}
                />,
              ]
              if(this.canEdit(record) && this.canView) {
                a=a.concat([
                  <a-divider type="vertical"/>,
                  <a-icon
                    style="cursor: pointer; color: #52c41a;"
                    type="file-search"
                    onClick={() => this.$emit('preview', record)}
                  />
                ])
              }
              return a
            } else {
              let a = [
                <a-icon
                style="cursor: pointer; color: #fa554c;"
                type="delete"
                onClick={() => this.$emit('delete', { record, index })}
                />,
              ]
              if(this.canEdit(record) && this.canView) {
                a=a.concat([
                  <a-divider type="vertical"/>,
                  <a-icon
                    style="cursor: pointer; color: #52c41a;"
                    type="file-search"
                    onClick={() => this.$emit('preview', record)}
                  />
                ])
              }
              return a
            }
          },
          width: '15%',
          align: 'center',
        },
        {
          title: this.$t('page_resource_pool_file_name'),
          dataIndex: 'displayName',
          ellipsis: true,
          width: '35%',
        },
        {
          title: this.$t('page_resource_pool_size'),
          dataIndex: 'contentLength',
          customRender: val => {
            if (isNull(val)) {
              return '-'
            } else {
              return humanStorageSize(val)
            }
          },
          width: '20%',
        },
        {
          title: this.$t('page_resource_pool_file_type'),
          dataIndex: 'suffix',
          width: '25%',
        },
      ]
    }
  }
  canEdit(record){
    let bool = false
    if(record.displayName.indexOf('.') != -1){
      var a = /.*\.(.*)$/
      const suffix = a.exec(record.displayName)[1]
      bool = this.viewContentType.includes(suffix.toLowerCase())
    } else {
      bool = true
    }
    return bool
  }
  render() {
    const customRow = record => ({
      on: {
        click: () => {
          if (this.isCompare && record.suffix === 'txt') {
            this.$emit('diff', record)
          }
        },
      },
    })
    return (
      <a-table
        size="small"
        bordered={true}
        columns={this.columns}
        dataSource={this.data}
        loading={this.loading}
        pagination={false}
        rowKey="displayName"
        style={{ marginBottom: '16px' }}
        customRow={customRow}
      ></a-table>
    )
  }
}
